/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePasswordInput
 */
export interface UpdatePasswordInput {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordInput
     */
    newPassword?: string;
}

/**
 * Check if a given object implements the UpdatePasswordInput interface.
 */
export function instanceOfUpdatePasswordInput(value: object): value is UpdatePasswordInput {
    return true;
}

export function UpdatePasswordInputFromJSON(json: any): UpdatePasswordInput {
    return UpdatePasswordInputFromJSONTyped(json, false);
}

export function UpdatePasswordInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePasswordInput {
    if (json == null) {
        return json;
    }
    return {
        
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
    };
}

export function UpdatePasswordInputToJSON(json: any): UpdatePasswordInput {
    return UpdatePasswordInputToJSONTyped(json, false);
}

export function UpdatePasswordInputToJSONTyped(value?: UpdatePasswordInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newPassword': value['newPassword'],
    };
}

